import { useState } from 'react';

import useSubscriptions, {
  DEFAULT_SUBSCRIPTIONS_FILTERS
} from 'api/useSubscriptions';

import DataTable from 'components/DataTableComponent/DataTable';
import FilterDropdownCard from 'components/Filter/FilterDropdownCard';
import FilterSearchCard from 'components/Filter/FilterSearchCard';

import {
  BillingPeriodUnit,
  SubscriptionStatus
} from '../../../common/contracts';
import { useSubscriptionsColumns } from '../hooks/use-subscriptions-columns';

export function SubscriptionsTable() {
  const [currentPage, setCurrentPage] = useState(0);
  const [billingPeriodFilter, setBillingPeriodFilter] = useState<string>('');
  const [subscriptionStatusFilter, setSubscriptionStatusFilter] =
    useState<string>('');
  const [planDisplayName, setPlanDisplayName] = useState<string>('');
  const [customerEmail, setCustomerEmail] = useState<string>('');
  const [subscriptionId, setSubscriptionId] = useState<string>('');
  const { columns } = useSubscriptionsColumns();
  const { getSubscriptions } = useSubscriptions({
    pageSize: DEFAULT_SUBSCRIPTIONS_FILTERS.pageSize!,
    offset: currentPage * DEFAULT_SUBSCRIPTIONS_FILTERS.pageSize!,
    status: subscriptionStatusFilter,
    billingPeriodUnit: billingPeriodFilter,
    planDisplayName: planDisplayName,
    customerEmail: customerEmail,
    subscriptionId: subscriptionId
  });

  const totalPages = Math.ceil(
    (getSubscriptions.data?.totalCount || 0) /
      DEFAULT_SUBSCRIPTIONS_FILTERS.pageSize!
  );

  return (
    <div>
      <div className="flex pb-3 pt-1 gap-3">
        <FilterSearchCard
          header="Display name"
          isLabelSearchBy
          filterValue={planDisplayName}
          setFilterValue={(value) => setPlanDisplayName(value)}
        />

        <FilterSearchCard
          header="Customer email"
          filterValue={customerEmail}
          setFilterValue={(value) => setCustomerEmail(value)}
        />
        <FilterDropdownCard
          header="Status"
          filterValue={subscriptionStatusFilter}
          setFilterValue={(value) => setSubscriptionStatusFilter(value)}
          options={[
            { label: 'Active', value: SubscriptionStatus.ACTIVE },
            { label: 'Overdue', value: SubscriptionStatus.OVERDUE },
            { label: 'Canceled', value: SubscriptionStatus.CANCELED },
            { label: 'Expired', value: SubscriptionStatus.EXPIRED },
            { label: 'Trial', value: SubscriptionStatus.TRIAL },
            { label: 'Pending', value: SubscriptionStatus.PENDING }
          ]}
        />
        <FilterDropdownCard
          header="Billing period"
          filterValue={billingPeriodFilter}
          setFilterValue={(value) => setBillingPeriodFilter(value)}
          options={[
            { label: 'Daily', value: BillingPeriodUnit.DAILY },
            { label: 'Weekly', value: BillingPeriodUnit.WEEKLY },
            { label: 'Monthly', value: BillingPeriodUnit.MONTHLY },
            { label: 'Yearly', value: BillingPeriodUnit.YEARLY }
          ]}
        />
        <FilterSearchCard
          header="Subscription ID"
          filterValue={subscriptionId}
          setFilterValue={(value) => setSubscriptionId(value)}
        />
      </div>

      <DataTable
        data={getSubscriptions.data?.subscriptions || []}
        columns={columns}
        rowIdIdentifier="_id"
        isLoading={getSubscriptions.isLoading}
        rowCount={getSubscriptions.data?.totalCount}
        rowsPerPage={DEFAULT_SUBSCRIPTIONS_FILTERS.pageSize}
        showPagination={totalPages > 1}
        manualPagination
        pageIndex={currentPage}
        pageCount={totalPages}
        onPageChange={setCurrentPage}
        bordered
      />
    </div>
  );
}
